import { clearAuthSessionStorage } from "./authSession";
import {
  clearPublishFormDraft,
} from "./publisherAgreementFlow";

export function clearPublisherClientSession(
  localStorageRef: Pick<Storage, "removeItem"> = localStorage,
  sessionStorageRef: Pick<Storage, "removeItem"> = sessionStorage,
): void {
  clearAuthSessionStorage(localStorageRef);
  clearPublishFormDraft(sessionStorageRef);
}
